import { render } from "./whoWeAre.vue?vue&type=template&id=2958c04a&scoped=true"
import script from "./whoWeAre.vue?vue&type=script&lang=js"
export * from "./whoWeAre.vue?vue&type=script&lang=js"

import "./whoWeAre.vue?vue&type=style&index=0&id=2958c04a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\amaan\\encanto-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2958c04a"]])

export default __exports__